export enum IPFSpanType {
	FORE_SPAN = 'fore_span',
	BACK_SPAN = 'back_span',
	OTHER = 'other',
}

export const IPF_SPAN_TYPES = [IPFSpanType.FORE_SPAN, IPFSpanType.BACK_SPAN, IPFSpanType.OTHER] as const;

const ipfSpanSet = new Set<string>(Object.values(IPFSpanType));
export function isIPFSpanType(value: string): value is IPFSpanType {
	return ipfSpanSet.has(value);
}
